import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import OutlookEmbed from '../components/OutlookEmbed';
import { Calendar as CalendarT } from 'react-feather';

export default function Calendar() {
	return (
		<div className="flex flex-col h-screen dashboard-page">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				<Sidebar />
				<main className="flex-1 overflow-auto p-8">
					<h1 className="text-3xl text-black pb-6 mt-6 one-line-title">
						<CalendarT size={34} /> Calendar
					</h1>
					<OutlookEmbed />
				</main>
			</div>
		</div>
	);
}
